// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FeeAccrualPortal,
    ObjectNoResponse,
    SupportBackfillFeeAccrualsPayload,
    SupportFeeAccrual,
    SupportFeeAccrualSortType,
    SupportBackfillFeeAccrualsPayloadToJSON,
    FeeAccrualPortalFromJSON,
    ObjectNoResponseFromJSON,
    SupportFeeAccrualFromJSON,
} from '../models';

export interface GetSupportFeeAccrualRequest {
    id: string;
}

export interface ListSupportAccrualsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportAccrualsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<SupportFeeAccrualSortType>;
}

export interface PostSupportBackfillFeeAccrualsRequest {
    supportBackfillFeeAccrualsPayload: SupportBackfillFeeAccrualsPayload;
}

export interface PostSupportFeeAccrualVoidRequest {
    id: string;
}

/**
 * no description
 */
export class FeeAccrualApi extends runtime.BaseAPI {

    /**
     * Get the accrual portal
     * Get the accrual portal
     */
    async getProviderFeeAccrualPortalRaw(): Promise<runtime.ApiResponse<FeeAccrualPortal>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:fee_accrual"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/fee_accrual/portal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FeeAccrualPortalFromJSON(jsonValue));
    }

    /**
     * Get the accrual portal
     * Get the accrual portal
     */
    async getProviderFeeAccrualPortal(): Promise<FeeAccrualPortal> {
        const response = await this.getProviderFeeAccrualPortalRaw();
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getSupportFeeAccrualRaw(requestParameters: GetSupportFeeAccrualRequest): Promise<runtime.ApiResponse<SupportFeeAccrual>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportFeeAccrual.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fee_accrual/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportFeeAccrualFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getSupportFeeAccrual(requestParameters: GetSupportFeeAccrualRequest): Promise<SupportFeeAccrual> {
        const response = await this.getSupportFeeAccrualRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get the accrual portal
     * Get the accrual portal
     */
    async getSupportFeeAccrualPortalRaw(): Promise<runtime.ApiResponse<FeeAccrualPortal>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fee_accrual/portal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FeeAccrualPortalFromJSON(jsonValue));
    }

    /**
     * Get the accrual portal
     * Get the accrual portal
     */
    async getSupportFeeAccrualPortal(): Promise<FeeAccrualPortal> {
        const response = await this.getSupportFeeAccrualPortalRaw();
        return await response.value();
    }

    /**
     * Gets a list of fee accruals
     * Get a list of fee accruals
     */
    async listSupportAccrualsRaw(requestParameters: ListSupportAccrualsRequest): Promise<runtime.ApiResponse<Array<SupportFeeAccrual>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fee_accrual`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportFeeAccrualFromJSON));
    }

    /**
     * Gets a list of fee accruals
     * Get a list of fee accruals
     */
    async listSupportAccruals(requestParameters: ListSupportAccrualsRequest): Promise<Array<SupportFeeAccrual>> {
        const response = await this.listSupportAccrualsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Backfill finalized fee accruals
     * Backfill finalized fee accruals
     */
    async postSupportBackfillFeeAccrualsRaw(requestParameters: PostSupportBackfillFeeAccrualsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportBackfillFeeAccrualsPayload'] === null || requestParameters['supportBackfillFeeAccrualsPayload'] === undefined) {
            throw new runtime.RequiredError('supportBackfillFeeAccrualsPayload','Required parameter requestParameters.supportBackfillFeeAccrualsPayload was null or undefined when calling postSupportBackfillFeeAccruals.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fee_accrual/backfill`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportBackfillFeeAccrualsPayloadToJSON(requestParameters['supportBackfillFeeAccrualsPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Backfill finalized fee accruals
     * Backfill finalized fee accruals
     */
    async postSupportBackfillFeeAccruals(requestParameters: PostSupportBackfillFeeAccrualsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportBackfillFeeAccrualsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Void fee accrual
     * Void fee accrual
     */
    async postSupportFeeAccrualVoidRaw(requestParameters: PostSupportFeeAccrualVoidRequest): Promise<runtime.ApiResponse<SupportFeeAccrual>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportFeeAccrualVoid.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/fee_accrual/{id}/void`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportFeeAccrualFromJSON(jsonValue));
    }

    /**
     * Void fee accrual
     * Void fee accrual
     */
    async postSupportFeeAccrualVoid(requestParameters: PostSupportFeeAccrualVoidRequest): Promise<SupportFeeAccrual> {
        const response = await this.postSupportFeeAccrualVoidRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListSupportAccrualsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
